import AppPrivateRoutes from "./AppPrivateRoutes";

export default AppPrivateRoutes;
